import Vue from 'vue';
export default Vue.extend({
    inheritAttrs: false,
    props: {
        /** text value for input.  Use `v-model` */
        value: { type: [String, Number], required: false, default: '' },
        /** vee-validate3 errors */
        errors: { type: Array, required: false, default: () => [] },
        /** place holder text to display */
        placeholder: { type: String, required: false, default: '' },
        /** physical width of box on screen. */
        width: { type: String, required: false, default: '100%' },
        focus: { type: Boolean, required: false, default: false },
    },
    computed: {
        hasErrors() {
            return this.errors ? this.errors.length > 0 : false;
        }
    },
    watch: {
        focus(val) {
            if (val) {
                this.$refs.input.focus();
            }
        }
    },
    mounted() {
        if (this.focus) {
            this.$nextTick(() => {
                this.$refs.input.focus();
                this.$refs.input.select();
            });
        }
    },
});
